import loginSuccess from "./loginSuccess";
import getFormattedSourceDetails from "@Utils/getFormattedSourceDetails";
import axios from "axios";
import config from "@Config/index";
import setLeadPersonalDetails from "helpers/setPersonalDetailsLocalstorage";

const sendAccessToken = async ({
  token,
  type,
  nextRoute,
  additionalData,
  authorization_code,
}: any) => {
  const options: any = {};
  // Show Nanobar
  const source_details = getFormattedSourceDetails();

  if (type === "wechat") {
    options.url_path = "/api/v0/users/connect_wechat";
    options.data = { code: authorization_code, source_details };
  }

  if (type === "facebook") {
    options.url_path = "/api/v0/users/connect_facebook";
    options.data = { access_token: token, source_details };
  }

  if (type === "google" || type === "google_one_tap") {
    options.url_path = "/api/v0/users/connect_google_id";
    options.data = { id_token: token, source_details };
  }

  if (type === "apple") {
    options.url_path = "/api/v0/users/connect_apple";
    options.data = { id_token: token, authorization_code, user: additionalData, source_details };
  }

  try {
    const { data } = await axios.post(
      `${config.API_URL}${options.url_path}`,
      {
        ...options.data,
      },
      {
        withCredentials: true,
      },
    );
    loginSuccess(data?.data, type, nextRoute);
    setLeadPersonalDetails(data?.data);
  } catch (error: any) {
    console.error(error);
  }
};

export default sendAccessToken;
